import request from '@/common/ajax';
import qs from 'qs';
import { getActivityId } from '@/utils/wechatAuth';

// 微信转发配置
export function getWechatConfig(data) {
  return request({
    url:
      '/jssdk.php?url=' +data,
    method: 'get',
    data: {},
  });
}

// 获取页面背景图等（无需授权，id 从页面 URL 参数获取）
export function getGiftvote(data) {
  const id = getActivityId();
  return request({
    url: `/System/Api/getGiftvote?id=${id}`,
    method: 'get',
    data: {},
  });
}

// 活动接口（前端授权：支持传入 code 或 openid）
export function queryActivity(data) {
  const params = data || {};
  const id = getActivityId();
  return request({
    url: `/show/1/${id}?key=4iwicwsize&${qs.stringify(params)}`,
    method: 'get',
    data: {},
  });
}

// 作品
export function queryWorkList({ label, topic, params }) {
  const id = getActivityId();
  return request({
    url: `/item/1/${id}/${label}/${topic}?key=4iwicwsize&${qs.stringify(params)}`,
    method: 'get',
    data: {},
  });
}

// 作品详情
export function queryWorkDetail(data) {
  const id = getActivityId();
  return request({
    url: `/item_detail/1/${id}/${data.id}?key=4iwicwsize`,
    method: 'get',
    data: {},
  });
}

// 主题
export function queryTopics(data) {
  const id = getActivityId();
  return request({
    url: `/topics/1/${id}/topic?key=4iwicwsize`,
    method: 'get',
    data,
  });
}

// 排行榜
export function queryRankingList(data) {
  const id = getActivityId();
  return request({
    url: `/show_top/1/${id}?key=4iwicwsize&` + qs.stringify(data),
    method: 'get',
    data: {},
  });
}

// 投票
export function voteUser(data) {
  const id = getActivityId();
  return request({
    url: `/vote/1/${id}/${data.id}/${data.dopl}?key=4iwicwsize`,
    method: 'post',
    data: {},
  });
}

// 添加姓名（传 code 验证）
export function userLogin(name, code) {
  const id = getActivityId();
  const query = qs.stringify({
    key: '4iwicwsize',
    name,
    ...(code ? { code } : {}),
  });
  return request({
    url: `/user_login/1/${id}?${query}`,
    method: 'post',
    data: {},
  });
}
// tou
export function confirmVote(label) {
  const id = getActivityId();
  return request({
    url: `/confirm/1/${id}?key=4iwicwsize&label=` + label,
    method: 'post',
    data: {},
  });
}
// 取消确认投票
export function cancleVote(label) {
  const id = getActivityId();
  return request({
    url: `/cancle/1/${id}?key=4iwicwsize&label=` + label,
    method: 'post',
    data: {},
  });
}